import type { RideCourse } from './course';
import type { RideState, RideTrack, TrackObject } from './model';

export function nextTechnical(objects: TrackObject[], distance: number) {
  return objects.find(o => o.type === 'technical' && !o.taken && o.feature && o.distance + o.feature.length >= distance)?.feature;
}
export function roadAdvice(s: RideState) {
  if (s.grade > .018) return { action: 'tempo', title: 'CLIMB · HOLD YOUR TEMPO', detail: 'Auto-pedal carries the climb. Save Shift for a short attack after the crest.' };
  if (s.grade < -.022 && s.speed > 9) return { action: 'coast', title: 'DESCENT · COAST NOW', detail: 'Hold C. Let gravity carry your speed while energy recovers and heart rate falls.' };
  if (s.draft > .25 && s.speed > 10 && s.stamina < 90) return { action: 'coast', title: 'ON A WHEEL · RECOVER', detail: 'Hold C for 2–3 seconds in the slipstream. Release it as the gap opens.' };
  if (s.stamina < 28) return { action: 'coast', title: 'RECOVER BEFORE ATTACKING', detail: 'Hold C for a short breather, then release to resume tempo. Avoid sprinting on empty.' };
  if (s.stamina > 70 && s.elapsed > 12) return { action: 'attack', title: 'FRESH LEGS · PICK YOUR MOMENT', detail: 'Follow a wheel, move alongside, then hold Shift for a short burst to overtake.' };
  return { action: 'tempo', title: 'TEMPO IS AUTOMATIC', detail: 'W / ↑ also rides at tempo. Shift is a short sprint. Watch for a green coasting window.' };
}

/** A fixed vertical scale makes an approaching climb comparable to the current slope. */
export function slopeProfile(course: RideCourse, track: RideTrack, distance: number) {
  const here = course.sample(distance).y;
  return Array.from({ length: 31 }, (_, i) => {
    const d = Math.min(track.length, distance + i * 6);
    return `${(i * 8).toFixed(0)},${Math.max(5, Math.min(65, 35 - (course.sample(d).y - here) * 2.2)).toFixed(1)}`;
  }).join(' ');
}
